import { request } from "../../core";

/**
 * 获取岗位列表
 * @param {object} data
 * @returns
 */
export function getPositionList(data) {
  return request.post({
    url: "/api/ums/umsPosition/getPositionList",
    data,
  });
};

/**
 * 切换岗位
 * @param {object} data
 * @returns
 */
export function switchPosition(data) {
  return request.post({
    url: "/api/ums/umsPosition/switchPosition",
    data,
  });
};
